import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import AddButton from "../../components/AddButton";
import {
  ACTIONS,
  AuthRoutes,
  RADIOLOGISTTYPE,
  USERTYPES,
} from "../../constants/Constants";
import userContext from "../../context/users/UserContext";
import {
  changeUserStatus,
  getProviderList,
  getRadiologistList,
  getSupervisorList,
  fetchEditUserData,
  changeUserLockStatus
} from "../../service/UserService";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import DataTable from "../../components/DataTable/DataTable";
import { PrimaryButton } from "@fluentui/react";
import NotAuthorized from "../../components/NotAuthorized";
import { RadiologistColumns } from "../../constants/Columns/RadiologistUser";
import ListView from "../../components/ListView/ListView";
import loaderContext from "../../context/loader/LoaderContext";
import { SupervisorColumns } from "../../constants/Columns/Supervisor";
import ListViewV2 from "../../components/ListViewV2/ListViewV2";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import PasswordResetModal from "../../components/PasswordResetModal/PasswordResetModal";
const queryClient = new QueryClient();

const RadiologistList = () => {
  const navigate = useNavigate();
  const [t, i18n] = useTranslation();
  const [updateCurrentPage, setUpdateCurrentPage] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput:null,
    filterUpdate:0
  });
  const [dataQueryState, setDataQueryState] = useState({});
  const [sortObj,setSortObj] = useState({
    sortFieldText : "",
    sortFieldValue : "",
    sortDir : false,
    selected : false
  });
    const [selectedUsername, setSelectedUsername] = useState("");
    const [showResetModal, setShowResetModal] = useState(false);
    const [fullName,setFullName]=useState("");
  const {setLoaderRunning,ref} = useContext(loaderContext);

  const { roles, authenticated, loadByUsername, firmId } = useContext(userContext);

  const [userId, setUserId] = useState(0);
  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }

  const fetchRadiologistList = async (
    page,
    pageSize,
    pageFilter,
    pageSortBy
  ) => {
    let sortyByDir = true;
    let sortParams = "username";
    if (pageSortBy != undefined && pageSortBy.length > 0) {
      sortParams = pageSortBy[0].id;
      sortyByDir = pageSortBy[0].desc;
    }

    const body = {
      paginationDto: {
        pageNumber: page,
        pageSize: pageSize,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
      },
    };

    let response;
    console.log(roles[0]);
    if (roles[0] === USERTYPES.ADMIN) {
      response = await getRadiologistList(body);
    } else {
      response = await getProviderList(body);
    }

    console.log(response);

    // const response = await getRadiologistList(body);
    if (response.status === 200 && response.data.result === "SUCCESS") {
      console.log("I am here");
      if (
        roles[0] === USERTYPES.FIRMADMIN && (
          response.data.data.userPage.content != null ||
          response.data.data.userPage.content != undefined)
      ) {
        setUserId(response.data.data.userId);
        // setFirmId(response.data.data.firmId);

        const data = {
          results: (process.env.REACT_APP_ENTERPRISE_PLATFORM == "true") ? response.data.data.userPage.content : response.data.data.providerPage.content,
          count: response.data.data.userPage.totalElements,
        };
        console.log(data.results);
        return data;
      } else if (
        roles[0] === USERTYPES.ADMIN && (
          response.data.data.userList != null ||
          response.data.data.userList != undefined)
      ) {
        setUserId(response.data.data.userId);
        // setFirmId(response.data.data.firmId);
        const data = {
          results: response.data.data.userList,
          count: response.data.data.totalElements,
        };
        console.log(data.results);
        return data;
      }
      // setAdminUserData(response.data.data);
      // setAdminUserList(response.data.data.userList);
      // listLength = adminUserList.length;
    }
  };

  const fetchData = async (options) => {
    
    // let page = options.pageIndex;
    // let pageSize = options.pageSize;
    console.log("--- FetchData ---",options);
    let sortParams = "id";
    let sortyByDir = false;

    if (options.sortObj.sortFieldValue != undefined && options.sortObj.sortFieldValue.length > 0) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: 10,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
        filterInput: filterObj.filterInput == null ? "": filterObj.filterInput
      }
    };

    setLoaderRunning(true);
    ref.current.continuousStart();
    let response;
    if (roles[0] === USERTYPES.ADMIN) {
      response = await getRadiologistList(body);
    } else {
      response = await getProviderList(body);
    }
    
    let data = null;
    let pageCount = null;  
    if (response.status === 200 && response.data.result === "SUCCESS") {
      setLoaderRunning(false);
      ref.current.complete();

         if (
          roles[0] === USERTYPES.FIRMADMIN && (
            response.data.data.userPage.content != null ||
            response.data.data.userPage.content != undefined)
        ) {
          setUserId(response.data.data.userId);

          return {
            rows: (process.env.REACT_APP_ENTERPRISE_PLATFORM == "true") ? response.data.data.userPage.content : response.data.data.providerPage.content,
            pageCount: response.data.data.userPage.totalPages,
          };

        } else if (
          roles[0] === USERTYPES.ADMIN && (
            response.data.data.userList != null ||
            response.data.data.userList != undefined)
        ) {
          setUserId(response.data.data.userId);
          // setFirmId(response.data.data.firmId);
          return {
            rows: response.data.data.userList,
            pageCount: response.data.data.totalPages,
          };
        }


         return {
          rows: data,
          pageCount: pageCount,
        };
    }else{
      setLoaderRunning(false);
      ref.current.complete();
      return {
        rows: data,
        pageCount: pageCount,
      }
    }
  };

  function handleCaching(id) {
    // //setUpdateCurrentPage(!updateCurrentPage);
    // setFilterObj(()=>{
    //   const newItem = { ...filterObj };
    //   newItem.filterUpdate = newItem.filterUpdate + 1;
    //   return newItem;
    // })
    let newIndex = -1;
    let newData = dataQueryState?.data?.rows.filter((row, index) => {
      if (row.id == id) {
        newIndex = index;
        return true;
      }
      return false;
    });  
    setDataQueryState(() => {
      const newValue = {
        ...dataQueryState
      };
      if(newValue.data.rows[newIndex] != null){
        newValue.data.rows[newIndex].active = !newValue.data.rows[newIndex].active; 
      }
      return newValue;
    });
  }

  const handleActionButton = async (event, data, cell) => {
    event.stopPropagation();
    try {
      const response = await changeUserStatus(data);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        // handleCaching(data);
        ReloadData(data, true);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleLockButton = async (event, data, cell) => {
    event.stopPropagation();
    try {
      const response = await changeUserLockStatus(data);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        // handleCaching(data);
        ReloadData(data, false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  function ReloadData(id, actionOrLocked) {
    // setUpdateCurrentPage(() => !updateCurrentPage);
    // setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
     let newIndex = -1;
     let newData = dataQueryState?.data?.rows.filter((row, index) => {
       if (row.id == id) {
         newIndex = index;
         return true;
       }
       return false;
     });  
     setDataQueryState(() => {
       const newValue = {
         ...dataQueryState
       };
       if(newValue.data.rows[newIndex] != null){
          if(actionOrLocked){
            newValue.data.rows[newIndex].active = !newValue.data.rows[newIndex].active;
          }else if(!actionOrLocked){
            newValue.data.rows[newIndex].accountNonLocked = !newValue.data.rows[newIndex].accountNonLocked;
          }
       }
       return newValue;
     });
 
   }

  const handleUserClick = async (cell) => {
    cell = cell.row.original;
    navigate(AuthRoutes.MYVIEWUSER + "?id=" + cell.id, {});
  };

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);
  const openPasswordReset = (event,fullName,username) => {
    event.stopPropagation(); 
    setSelectedUsername(username);
    setShowResetModal(true);
    setFullName(fullName);
  }; 
  const columns = SupervisorColumns(userId, handleActionButton, handleUserClick, handleLockButton,openPasswordReset);

  const buttonsTopBar = [{
    key: "1",
    button: <Link
      key="1"
      to={AuthRoutes.MYADDRADIOLOGIST}
      state={{
        action: ACTIONS.ADD,
        loggedInUserId: userId,
        loggedInUserRole: roles[0],
        userType: USERTYPES.RADIOLOGIST,
      }}
    >
      <div className="add-button-list-view">
        {/* <AddButton text={t("radiologist.add-radiologist")} /> */}
        <PrimaryButton
         text={t("radiologist.add-radiologist")}
          className={"common-default-active-button list-view-top-buttons-styles"}
        />
      </div>

    </Link>
  },
  ]


  const options = [
    { key: 'username', text: t("user.username") },
    { key: 'firstName', text:  t("user.first-name") },
    { key: 'lastName', text: t("user.last-name") },
    { key: 'email', text: t("user.email") },
    { key: 'mobile', text: t("user.mobile") },
    { key: 'active', text: t("user.action") },
  ];

  const handleApplyClick = (filterValue) => {
    if(filterValue != undefined)filterValue = filterValue.trim();
    setPagination(()=>{
      const newItem = {...paginationObj};
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(()=>{
    setFilterObj(() => {
      const newItem = { ...filterObj };
      newItem.filterInput = filterValue;
      newItem.filterUpdate = newItem.filterUpdate + 1;
      return newItem;
    });
    },100);
  };

  return (
    <> <PasswordResetModal
                username={selectedUsername}
                visible={showResetModal}
                onClose={() => setShowResetModal(false)}
                fullName={fullName}
              />
      {(roles[0] === USERTYPES.RADIOLOGIST ||
        roles[0] === USERTYPES.ADMIN ||
        roles[0] === USERTYPES.FIRMADMIN) && (
          <ListViewV3 
            buttonsTopBar={buttonsTopBar}
            sortDropdownOptions={options}
            fetchData = {fetchData}
            columns={columns}
            handleUserClick={handleUserClick}
            filterObj={filterObj}
            setFilterObj={setFilterObj}
            handleApplyClick={handleApplyClick}
            setDataQueryState={setDataQueryState}
            dataQueryState={dataQueryState}
            sortObj = {sortObj}
            setSortObj = {setSortObj}
            setPagination = { setPagination}
            paginationObj = {paginationObj}
            uniqueKey= {"Radiologist"}
            heading={roles[0] === USERTYPES.ADMIN ? t("radiologist.radiologist"):null}
    />
        )}
      {roles.length != 0 && roles[0] === USERTYPES.RADIOLOGIST && (
        <NotAuthorized />
      )}
    </>
  );
};

export default RadiologistList;
